<template>
  <div>
    <canvas
      :id="'canvas' + palletId + random"
      class="pallet"
      :class="{ palletDoesntFit: doesNotFit }"
      @mousemove="mouseMoved"
      @mouseout="mouseIsOver = -1"
    ></canvas>
  </div>
</template>

<script>
import Helper from "@/models/Helper.js";
export default {
  props: [
    "pallet",
    "divider",
    "settings",
    "showTexts",
    "dontUpdate",
    "truck",
    "showPicture",
    "showErrors"
  ],
  data() {
    return {
      palletId: this.pallet.id,
      random: Math.floor(Math.random() * 1000000),
      //used for selecting product
      selectedProduct: null,
      mouseIsOver: -1
    };
  },
  mounted() {
    this.initialize();
  },
  computed: {
    doesNotFit() {
      if(!this.showErrors){
        return false;
      }
      if(this.pallet.temporary){
        return false;
      }
      if (this.pallet.getWeight() > this.pallet.max_weight) {
        return true;
      }
      if(!this.pallet.productsFit()){
        return true;
      }
      return false;
    }
  },
  watch: {
    pallet() {
      if (this.dontUpdate) {
        return 0;
      }
      this.initialize();
    },
    divider() {
      if (this.dontUpdate) {
        return 0;
      }
      this.initialize();
    },
    mouseIsOver(val) {
      if (val == -1 && this.selectedProduct != null) {
        this.selectedProduct = null;
        this.$emit("hideProduct");
      }
    }
  },
  methods: {
    async initialize() {
      await Helper.timeout(20);
      let canvas = document.getElementById(
        "canvas" + this.palletId + this.random
      );
      if (canvas == null) {
        return 0;
      }
      if (this.pallet == null) {
        return 0;
      }
      let ctx = canvas.getContext("2d");
      canvas.width = this.pallet.length / this.divider;
      canvas.height = this.pallet.width / this.divider;
      ctx.scale(1 / this.divider, 1 / this.divider);
      ctx.lineWidth = 200 * (1 / this.divider);
      ctx.fillStyle = "#FFFFFF";
      ctx.lineWidth = 10;
      if (this.pallet.length == 0) {
        return 0;
      }
      if (this.pallet.height == 0) {
        return 0;
      }
      drawProducts(ctx, this.pallet, this);
    },

    mouseMoved() {
      if (!this.showPicture) return;
      const products = this.pallet.products.slice();
      const mousePos = {
        x: event.offsetX,
        y: event.offsetY
      };

      //try to find product within we're hovering
      const hoveringProduct = products.find(e => {
        return (
          mousePos.x > e.x / this.divider &&
          mousePos.x < (e.x + e.getWidth()) / this.divider &&
          mousePos.y > e.y / this.divider &&
          mousePos.y < (e.y + e.depth) / this.divider &&
          e.z == 0
        ); // always take the bottom one if more than one
      });
      if (hoveringProduct != null) {
        hoveringProduct.select(this);
      } else {
        this.selectedProduct = null;
        this.mouseIsOver = -1; // if not over any product reset mouse over
      }
    }
  }
};
function drawProducts(ctx, pallet, vue) {
  ctx.strokeStyle = "rgb(0,0,0)";
  pallet.products.forEach(product => {
    const x = product.x;
    const y = product.y;
    const width = product.getWidth();
    const height = product.depth;
    ctx.fillStyle =
      (product.status > 12 && product.status < 15) ? "rgb(152, 209, 160)" : "rgb(255,255,255)";
    if (product.getProductStack(pallet.products).getHeight() + pallet.pallet_height > pallet.max_height) {
      ctx.fillStyle = "red";
    }
    ctx.fillRect(x, y, width, height); //draw rectangles
    ctx.strokeRect(x, y, width, height); //draw borders
    vue.showTexts
      ? drawProductText(ctx, product, x, y, width, height, vue)
      : null;
  });
}

function drawProductText(ctx, product, x, y, width, height) {
  const text = product.toString();
  ctx.font = "40px Arial";
  ctx.fillStyle = "rgb(0,0,0)";
  ctx.textAlign = "center";
  ctx.textBaseline = "middle";
  ctx.fillText(text, x + width / 2, y + height / 2);
}
</script>

<style>
.pallet {
  background-color: rgb(233, 215, 159);
}
.palletDoesntFit {
  background-color: red;
}
</style>
